import React from "react";

// reactstrap components
import {
  NavbarBrand,
  Navbar,
  Container
} from "reactstrap";

class AdminNavbar extends React.Component {
  render() {
    return (
      <>
        <Navbar
          className="navbar-top navbar-horizontal navbar-dark"
          expand="md"
        >
          <Container className="px-4">
            <NavbarBrand>
              <img alt="..." src={require("assets/img/brand/logo.png")} />
            </NavbarBrand>
            <button className="navbar-toggler" id="navbar-collapse-main">
              <span className="navbar-toggler-icon" />
            </button>
          </Container>
        </Navbar>
      </>
    );
  }
}

export default AdminNavbar;
